<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="container-fluid my-3">

    <div class="filter my-3">
      <div class="filter-head">
        <h4>{{ grade ? `حجوزات ${grade.name}` : 'جدول الطلاب' }} ({{ pagination }})</h4>
        <div class="buttons">
          <BulkSms v-if="grade?.id" :academic_year_id="grade.id" />
          <router-link :to="`/grades/${gradeSlug}/attendance`" class="btn PrimaryButton">الغياب</router-link>
          <router-link :to="`/grades/${gradeSlug}/absence`" class="btn PrimaryButton">شيت الدفع</router-link>
          <router-link :to="`/grades/${gradeSlug}/students/barcodes`" class="btn btn-outline-primary">
            <i class="pi pi-barcode me-1"></i> باركود الطلاب
          </router-link>
          <router-link :to="`/grades/${gradeSlug}/students/add`" class="btn PrimaryButton">إضافة حجز</router-link>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-6 col-md-12 col-12">
          <div class="form-group">
            <label>ابحث</label>
            <input type="search" class="form-control" placeholder="ابحث" v-model="word" @keyup="debounceFetch">
          </div>
        </div>
        <!-- <div class="col-lg-2 col-md-6 col-12">
          <div class="form-group d-flex flex-column">
            <label>الدرجة</label>
            <div class="d-flex gap-1">
              <input type="text" class="form-control" placeholder="Min" v-model="min_degree" @keyup="fetchReservation">
              <input type="text" class="form-control" placeholder="Max" v-model="max_degree" @keyup="fetchReservation">
            </div>
          </div>
        </div> -->
        <div class="col-lg-2 col-md-6 col-12">
          <div class="form-group d-flex flex-column">
            <label>حالة الحجز</label>
            <Dropdown v-model="status" :options="statusList" showClear optionLabel="title" placeholder="حالة الحجز" @change="fetchReservation" />
          </div>
        </div>
        <div class="col-lg-2 col-md-6 col-12">
          <div class="form-group d-flex flex-column">
            <label>الجنس</label>
            <Dropdown v-model="gender" :options="genderList" showClear optionLabel="title" placeholder="الجنس" @change="fetchReservation" />
          </div>
        </div>
        <div class="col-lg-2 col-md-3 col-12">
          <div class="d-flex">
            <div class="form-group d-flex flex-column mx-1">
              <label class="non_opacity">Excel</label>
              <button class="btn btn-success px-3" @click="exportToExcel"><i class="pi pi-file-excel"></i></button>
            </div>
            <div class="form-group d-flex flex-column mx-1">
              <label class="non_opacity">PDF</label>
              <button class="btn btn-danger px-3" v-print="'#reservationTable'"><i class="pi pi-file-pdf"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row reservation-table">
      <div id="reservationTable" class="a4">
        <div class="first-screen-pdf">
          <h1>كشوفات طلاب</h1>
          <h2>{{ grade?.name ?? '' }}</h2>
          <h3>{{ gender?.id === 1 ? 'بنين' : gender?.id === 2 ? 'بنات' : '' }} ( {{ pagination }} )</h3>
        </div>
        <table class="table table-striped">
          <thead>
            <tr>
              <th>#</th>
              <th>رقم حجز الطالب</th>
              <th>
                <span @click="sortByName" class="d-flex align-items-center fw-bold gap-2 p-0 m-0" style="cursor:pointer">
                  الاسم <i :class="sortAsc ? 'pi pi-sort-alpha-down' : 'pi pi-sort-alpha-up'"></i>
                </span>
              </th>
              <!-- <th>
                <span @click="sortByDegree" class="d-flex align-items-center fw-bold gap-2 p-0 m-0" style="cursor:pointer">
                  الدرجة <i :class="sortDegree ? 'pi pi-sort-numeric-down' : 'pi pi-sort-numeric-down-alt'"></i>
                </span>
              </th> -->
              <!-- <th>رقم الطالب</th> -->
              <th>رقم ولي الامر</th>
              <th>الجنس</th>
              <th>التعليم</th>
              <!-- <th>العنوان</th>
              <th>الشهادة</th> -->
              <th>حالة الحجز</th>
              <th>الحالة</th>
              <th>التحكم</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(r, index) in reservations.data" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ r.id }}</td>
              <td>{{ r.name }}</td>
              <!-- <td>{{ r.math_degree }}</td> -->
              <!-- <td>{{ r.student_phone }}</td> -->
              <td>{{ r.parent_phone }}</td>
              <td>{{ r.gender == 1 ? 'ولد' : 'بنت' }}</td>
              <td>{{ r.education_type == 1 ? 'عام' : r.education_type == 2 ? 'أزهر' : '' }}</td>
              <!-- <td>
                <span :tooltip="r.address" flow="up">{{ r.address ? r.address.slice(0,10) : '' }}</span>
              </td>
              <td>
                <Button label="الشهادة" @click="openCertificate(r.certificate_image)" v-if="r.certificate_image" />
                <span v-else>—</span>
              </td> -->
              <td>
                <template v-if="r.block === 0">
                  <span v-if="r.status == 0" class="status-badge status-badge--pending">معلق</span>
                  <span v-else-if="r.status == 1" class="status-badge status-badge--accepted">مقبول</span>
                  <span v-else-if="r.status == 2" class="status-badge status-badge--rejected">مرفوض</span>
                  <span v-else-if="r.status == 3" class="status-badge status-badge--waiting">انتظار الشهادة</span>
                </template>
                <span v-else class="status-badge status-badge--blocked">محظور</span>
              </td>
              <td>
                <button class="btn btn-success mx-1" v-if="r.status != 1" :tooltip="'قبول'" flow="up" @click="changeStatus(r.id, 1, index)">
                  <i class="pi pi-check-circle"></i>
                </button>
                <button class="btn btn-danger mx-1" v-if="r.status != 2" :tooltip="'رفض'" flow="up" @click="changeStatus(r.id, 2, index)">
                  <i class="pi pi-ban"></i>
                </button>
                <button class="btn btn-warning text-white mx-1" v-if="r.status != 0" :tooltip="'تعليق'" flow="up" @click="changeStatus(r.id, 0, index)">
                  <i class="pi pi-exclamation-circle"></i>
                </button>
                <!-- <button class="btn btn-info text-white mx-1" v-if="r.status != 3" :tooltip="'انتظار شهادة'" flow="up" @click="changeStatus(r.id, 3, index)">
                  <i class="pi pi-images"></i>
                </button> -->
              </td>
              <td>
                <router-link class="btn btn-info text-white mx-1" :tooltip="'تعديل كلمة المرور'" flow="up" :to="`/update_password/${r.user_id}`">
                  <i class="pi pi-unlock"></i>
                </router-link>
                <router-link class="btn btn-primary text-white mx-1" :tooltip="'تعديل'" flow="up" :to="`/user/edit/${r.user_id}`">
                  <i class="pi pi-pencil"></i>
                </router-link>
                <button :class="`btn ${r.block === 0 ? 'btn-danger' : 'btn-success'} text-white mx-1`" :tooltip="r.block === 1 ? 'إلغاء حظر' : 'حظر'" flow="up" @click="blockStudent(r.user_id)">
                  <i :class="`pi ${r.block === 0 ? 'pi-ban' : 'pi-circle'}`"></i>
                </button>
                <button class="btn btn-danger text-white mx-1" :tooltip="'حذف'" flow="up" @click="deleteReservation(r.id)">
                  <i class="pi pi-trash"></i>
                </button>
              </td>
            </tr>
            <tr v-for="n in extraRows" :key="'empty-' + n" class="empty-row">
              <td v-for="_ in 12" :key="_"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-md-10 col-12">
        <pagination :data="reservations" class="mx-auto d-flex align-items-center justify-content-center pagination" @pagination-change-page="fetchReservation">
          <template v-slot:prev-nav>&lt;</template>
          <template v-slot:next-nav>&gt;</template>
        </pagination>
      </div>
      <div class="col-md-2 col-12 mt-md-0 mt-3">
        <div class="form-group d-flex justify-content-center">
          <Dropdown v-model="per_page" :options="perPages" showClear optionLabel="title" placeholder="عدد الطلاب" @change="fetchReservation" />
        </div>
      </div>
    </div>

  </div>

  <Dialog v-model:visible="visible" :dismissableMask="true" modal header="صورة الشهادة">
    <Image :src="certificateImage" alt="certificate" class="certificate_image" preview />
  </Dialog>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import Image from 'primevue/image';
import pagination from 'laravel-vue-pagination';
import * as XLSX from 'xlsx/xlsx.mjs';
import Breadcrumb from '@/components/global/breadcrumb.vue';
import BulkSms from '@/components/reservation/BulkSms.vue';
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
  name: 'GradeStudents',
  components: { Dialog, Button, Dropdown, Image, pagination, Breadcrumb, BulkSms },

  data() {
    return {
      reservations: { data: [] },
      pagination: 0,
      word: '',
      status: null,
      min_degree: 0,
      max_degree: '',
      gender: '',
      per_page: null,
      sortAsc: true,
      sortDegree: true,
      orderByName: true,
      orderByDegree: false,
      searchTimeout: null,
      visible: false,
      certificateImage: '',
      statusList: [
        { id: 0, title: 'معلق' },
        { id: 1, title: 'مقبول' },
        { id: 2, title: 'مرفوض' },
        { id: 3, title: 'في انتظار الشهادة' },
        { id: 6, title: 'محظور' },
      ],
      genderList: [
        { id: 1, title: 'ولد' },
        { id: 2, title: 'بنت' },
      ],
      perPages: [
        { title: 'الكل', id: 10000 },
        { title: 10, id: 10 },
        { title: 25, id: 25 },
        { title: 50, id: 50 },
        { title: 100, id: 100 },
      ],
    };
  },

  computed: {
    gradeStore() { return useGradeStore(); },
    gradeSlug() { return this.$route.params.gradeSlug; },
    grade() {
      return this.gradeStore.activeGrades.find(g => g.slug === this.gradeSlug)
          || this.gradeStore.allGrades.find(g => g.slug === this.gradeSlug)
          || null;
    },
    breadcrumbs() {
      return [
        { name: 'الرئيسية', path: '/' },
        { name: this.grade?.name ?? 'المرحلة', path: `/grades/${this.gradeSlug}/students` },
      ];
    },
    extraRows() {
      return Math.max(0, 29 - (Number(this.pagination) % 29));
    },
  },

  methods: {
    debounceFetch() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => this.fetchReservation(), 1500);
    },

    fetchReservation(page = 1) {
      const fd = new FormData();

      if (this.grade?.id) {
        fd.append('academic_year_id', this.grade.id);
      }

      if (this.word) fd.append('word', this.word);
      if (this.status?.id === 6) {
        fd.append('is_block', 1);
      } else if (this.status !== null && this.status !== undefined) {
        fd.append('status', this.status.id);
      }
      if (this.min_degree) fd.append('min_degree', this.min_degree);
      if (this.max_degree) fd.append('max_degree', this.max_degree);
      if (this.gender) fd.append('gender', this.gender.id);
      if (this.orderByName) fd.append('order_by_name', 1);
      if (this.orderByDegree) fd.append('order_by_degree', 1);

      axios.defaults.headers.common['per_page'] = this.per_page?.id ?? 10;
      axios.post(`/all_reservations?page=${page}`, fd)
        .then(({ data }) => {
          this.reservations = data.data;
          this.pagination = data.data.meta.total;
        })
        .catch(() => { this.reservations = { data: [] }; });
    },

    changeStatus(id, status, index) {
      const labels = { 0: 'تعليق', 1: 'قبول', 2: 'رفض', 3: 'انتظار الشهادة' };
      Swal.fire({
        title: `تحويل إلى: ${labels[status]}؟`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: labels[status],
        cancelButtonText: 'رجوع',
      }).then(r => {
        if (!r.isConfirmed) return;
        const fd = new FormData();
        fd.append('reservation_id', id);
        fd.append('status', status);
        axios.post('/change_reservation_status', fd).then(({ data }) => {
          if (data.status) {
            Swal.fire('', data.message, 'success');
            this.reservations.data[index].status = status;
          }
        });
      });
    },

    deleteReservation(id) {
      Swal.fire({
        title: 'حذف الحجز؟',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'حذف',
        cancelButtonText: 'رجوع',
      }).then(r => {
        if (!r.isConfirmed) return;
        const fd = new FormData();
        fd.append('reservation_id', id);
        axios.post('delete_reservation', fd).then(({ data }) => {
          if (data.status) {
            Swal.fire('', data.message, 'success');
            this.reservations.data = this.reservations.data.filter(x => x.id !== id);
          }
        });
      });
    },

    blockStudent(userId) {
      Swal.fire({
        title: 'حظر / إلغاء حظر الطالب؟',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'تأكيد',
        cancelButtonText: 'رجوع',
      }).then(r => {
        if (!r.isConfirmed) return;
        const fd = new FormData();
        fd.append('user_id', userId);
        axios.post('toggle_block_user', fd).then(({ data }) => {
          if (data.status) {
            Swal.fire('', data.message, 'success');
            const found = this.reservations.data.find(x => x.user_id === userId);
            if (found) found.block = found.block === 0 ? 1 : 0;
          }
        });
      });
    },

    openCertificate(src) {
      this.certificateImage = src;
      this.visible = true;
    },

    sortByName() {
      this.orderByName = !this.orderByName;
      this.sortAsc = !this.sortAsc;
      this.orderByDegree = false;
      this.sortDegree = true;
      this.fetchReservation();
    },

    sortByDegree() {
      this.orderByDegree = !this.orderByDegree;
      this.sortDegree = !this.sortDegree;
      this.orderByName = false;
      this.sortAsc = true;
      this.fetchReservation();
    },

    exportToExcel() {
      const table = document.getElementById('reservationTable').cloneNode(true);
      const thead = table.querySelector('thead tr');
      const removeHeaders = ['الشهادة', 'حالة الحجز', 'رقم الطالب', 'الجنس', 'العنوان', 'التحكم', 'الحالة'];
      const headers = Array.from(thead.children);
      const removeIdx = headers.map((th, i) => removeHeaders.includes(th.textContent.trim()) ? i : -1).filter(i => i !== -1);
      removeIdx.sort((a, b) => b - a).forEach(i => thead.removeChild(headers[i]));
      table.querySelectorAll('tbody tr').forEach(row => {
        removeIdx.forEach(i => { if (row.children[i]) row.removeChild(row.children[i]); });
      });
      const ws = XLSX.utils.table_to_sheet(table);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      XLSX.writeFile(wb, `${this.grade?.name ?? 'students'}.xlsx`);
    },
  },

  async mounted() {
    // Ensure grades are loaded so grade info is available
    if (!this.gradeStore.activeGrades.length) {
      await this.gradeStore.fetchActiveGrades();
    }
    if (!this.gradeStore.allGrades.length) {
      await this.gradeStore.fetchAllGrades();
    }
    this.fetchReservation();
  },
};
</script>

<style scoped>
.empty-row { display: none; }
@media print { .empty-row { display: table-row !important; } }
</style>
